import BasicTable from './BasicTable';
import PaginatedTable from './PaginatedTable';

import './index.scss';

export {
  BasicTable,
  PaginatedTable,
}
